var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,16.754c-11.854,0-21.498,9.644-21.498,21.498c0,3.751,1,7.465,2.846,10.651l0.204,0.388 c6.557,10.958,6.582,12.314,6.665,16.819l0.039,1.728l0.04,0.433C36.694,74.425,41.834,79.246,48,79.246 c6.163,0,11.303-4.82,11.692-10.882l0.091-2.266c0.081-4.494,0.106-5.851,6.664-16.809l0.186-0.351 c1.874-3.261,2.864-6.955,2.864-10.688C69.497,26.397,59.854,16.754,48,16.754z M55.784,66.021l-0.038,1.643l-0.037,0.351 c-0.267,4.122-3.581,7.231-7.709,7.231c-4.13,0-7.445-3.11-7.718-7.314l-0.028-0.267l-0.037-1.638 c-0.009-0.493-0.02-0.958-0.038-1.404h15.642C55.804,65.067,55.793,65.53,55.784,66.021z M63.144,46.982l-0.162,0.311 c-4.182,6.99-5.906,10.446-6.637,13.33h-16.69c-0.731-2.886-2.457-6.345-6.64-13.337l-0.156-0.299 c-1.542-2.665-2.356-5.686-2.356-8.735c0-9.648,7.85-17.498,17.498-17.498c9.647,0,17.497,7.85,17.497,17.498 C65.497,41.299,64.684,44.318,63.144,46.982z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,22.419c-1.104,0-2,0.896-2,2s0.896,2,2,2c6.501,0,11.789,5.289,11.789,11.79c0,1.104,0.896,2,2,2s2-0.896,2-2 C63.789,29.502,56.706,22.419,48,22.419z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheory);
export default __webpack_public_path__ + "static/media/theory.72554e566d8e94665e0e78392706f753.svg";
export { ForwardRef as ReactComponent };